import * as actionTypes from "../actionTypes";
import { reviewType } from "../reducers/common_reload";

export const setPageCount = (page: number) => ({
  type: actionTypes.SET_PAGE_COUNT,
  payload: page
});

export const setServiceCategory = (category: number[]) => ({
  type: actionTypes.SET_SERVICE_CATEGORY,
  payload: category
});

export const setReview = (review: reviewType) => ({
  type: actionTypes.SET_REVIEW,
  payload: review
});

export const clearReview = () => ({
  type: actionTypes.CLEAR_REVIEW
});

export const setCheckOutError = (hasError: boolean) => ({
  type: actionTypes.SET_CHECKOUT_ERROR,
  payload: hasError
});

export const setAddressBlacklisted = (hasError: boolean) => ({
  type: actionTypes.SET_ADDRESS_BLACKLISTED,
  payload: hasError
});

export const setEmailBlacklisted = (hasError: boolean) => ({
  type: actionTypes.SET_EMAIL_BLACKLISTED,
  payload: hasError
});

export const setTimeError = (hasError: boolean) => ({
  type: actionTypes.SET_TIME_ERROR,
  payload: hasError
});
